import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper.scss";

import {
    productsSlider,
    sectionHeader,
    title,
    productsWrapper,
    productCard,
    imageContainer,
    button,
} from './products-slider.module.scss';

import {ISliderProduct} from "../../../../models/slider-product.model";
import useSwiperSettings from "../../../../hooks/home/banner-section/use-swiper-settings";

import SectionWrapper from "../../../molecules/section-wrapper";
import FashionFairySygnet from "../../../../assets/images/svg/Fashion-fairy-sygnet.svg";

interface IProductsSliderProps {
    products: ISliderProduct[];
}

const ProductsSlider: React.FC<IProductsSliderProps> = ({products}) => {

    const { settings } = useSwiperSettings();

    return (
        <SectionWrapper bgColor="white" className={productsSlider}>
            <header className={sectionHeader}>
                <h2 className={title}>
                    <span>Wybór</span>
                    <FashionFairySygnet aria-hidden="true" />
                </h2>
            </header>
            <div className={productsWrapper}>
                <Swiper
                    {...settings}
                    watchSlidesVisibility={true}
                    loop={products.length > 4}
                    slidesPerView={4}
                    spaceBetween={20}
                    breakpoints={
                    {
                        0: {
                            slidesPerView: 1.2,
                            spaceBetween: 12,
                        },
                        421: {
                            slidesPerView: 2,
                            spaceBetween: 14,
                        },
                        571: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },
                        1392: {
                            slidesPerView: 4,
                            spaceBetween: 18,
                        }
                    }
                }
                >
                    {products.map((product) => (
                        <SwiperSlide key={`productSlide-${product.productId}`}>
                            <article className={productCard}>
                                <a
                                    href={product.affiliateUrl || product.url}
                                    className={imageContainer}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Zobacz promowany produkt"
                                >
                                    <img src={product.imgUrl} alt={product.category || product.brandName || "Promowany produkt"} />
                                </a>
                                <a
                                    href={product.affiliateUrl || product.url}
                                    className={button}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Zobacz
                                </a>
                            </article>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </SectionWrapper>
    )
}

export default ProductsSlider
